module.exports = __webpack_public_path__ + "img/hat_female_cap.5c0b5ecc.png";